import { useState, useEffect } from "react";
import { fetchData } from "../../api";

export default function Footer() {
    const [footerData, setFooterData] = useState(null);
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null);

    useEffect(() => {
        fetchData("footers", true).then(data => setFooterData(data?.[0]));
    }, []);

    const handleNewsletterSubmit = async (e) => {
        e.preventDefault();
        if (!email) return;

        setIsSubmitting(true);
        setSubmitStatus(null);

        try {
            const response = await fetch(`${process.env.REACT_APP_STRAPI_URL || "https://api.bouwbedrijfgeluk.nl"}/api/newsletter/subscribe`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email })
            });

            const result = await response.json();

            if (response.ok) {
                setSubmitStatus({ type: 'success', message: 'Succesvol aangemeld voor de nieuwsbrief!' });
                setEmail('');
            } else {
                setSubmitStatus({ type: 'error', message: result.error || 'Er is een fout opgetreden.' });
            }
        } catch (error) {
            console.error('Newsletter subscription error:', error);
            setSubmitStatus({ type: 'error', message: 'Er is een fout opgetreden. Probeer het later opnieuw.' });
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!footerData) return null;

    return (
        <div className="relative">
            <div className="absolute -top-1 left-0 w-full overflow-hidden leading-none rotate-180">
                <svg className="w-full h-24" viewBox="0 0 1440 320" preserveAspectRatio="none">
                    <path
                        fill="#fff"  // your footer background color
                        d="M0,224C144,192,288,128,432,122.7C576,117,720,171,864,186.7C1008,203,1152,181,1296,154.7C1440,128,1440,128,1440,128L1440,320L0,320Z"

                    />
                </svg>
            </div>
            <footer className="bg-[#27352C] bg-no-repeat bg-cover pt-32 text-white py-12 px-6 md:px-16 max-sm:px-0 max-sm:pb-4">
                <div className="container grid grid-cols-1 md:grid-cols-4 gap-8">
                    {/* Left Section */}
                    <div>
                        <h2 className="text-[32px] text-[#FAFAFA] font-bold mb-3 max-lg:text-2xl">
                            {footerData?.Title}
                        </h2>
                        <p className="text-sm text-[#E9EBEA]">
                            {footerData?.Description}
                        </p>
                        
                        {/* Social Media Links */}
                        <div className="flex gap-4 mt-6">
                            {footerData?.SocialLinks?.map((link, index) => {
                                // Determine which icon to show based on URL
                                let IconComponent;
                                const url = link.URL?.toLowerCase() || '';
                                
                                if (url.includes('linkedin')) {
                                    IconComponent = () => (
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                                        </svg>
                                    );
                                } else if (url.includes('instagram')) {
                                    IconComponent = () => (
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12.017 0C8.396 0 7.989.013 7.041.048 6.094.082 5.52.204 5.036.43c-.524.234-.973.546-1.417.99-.445.445-.757.894-.991 1.417-.226.484-.348 1.058-.382 2.005C2.215 7.989 2.203 8.396 2.203 12.017s.013 4.028.048 4.976c.034.947.156 1.521.382 2.005.234.524.546.973.991 1.417.444.445.893.757 1.417.991.484.226 1.058.348 2.005.382 1.947.035 2.354.048 4.976.048s4.028-.013 4.976-.048c.947-.034 1.521-.156 2.005-.382.524-.234.973-.546 1.417-.991.445-.444.757-.893.991-1.417.226-.484.348-1.058.382-2.005.035-1.948.048-2.355.048-4.976s-.013-4.028-.048-4.976c-.034-.947-.156-1.521-.382-2.005-.234-.524-.546-.973-.991-1.417-.444-.445-.893-.757-1.417-.991-.484-.226-1.058-.348-2.005-.382C16.046.013 15.639 0 12.017 0zM12.017 2.163c3.204 0 3.584.012 4.85.07.784.036 1.203.166 1.485.276.374.145.64.319.92.599.28.28.453.546.598.92.11.282.24.701.276 1.485.058 1.265.07 1.645.07 4.849s-.012 3.584-.07 4.849c-.036.784-.166 1.203-.276 1.485-.145.374-.319.64-.599.92-.28.28-.546.453-.92.598-.282.11-.701.24-1.485.276-1.265.058-1.645.07-4.849.07s-3.584-.012-4.849-.07c-.784-.036-1.203-.166-1.485-.276-.374-.145-.64-.319-.92-.599-.28-.28-.453-.546-.599-.92-.11-.282-.24-.701-.276-1.485-.058-1.265-.07-1.645-.07-4.849s.012-3.584.07-4.849c.036-.784.166-1.203.276-1.485.145-.374.319-.64.599-.92.28-.28.546-.453.92-.599.282-.11.701-.24 1.485-.276 1.265-.058 1.645-.07 4.849-.07zm0 3.654c-2.68 0-4.846 2.165-4.846 4.845s2.166 4.845 4.846 4.845 4.845-2.165 4.845-4.845-2.165-4.845-4.845-4.845zm0 7.99c-1.738 0-3.146-1.408-3.146-3.145s1.408-3.145 3.146-3.145 3.145 1.407 3.145 3.145-1.407 3.145-3.145 3.145zm6.162-8.278c0 .625-.507 1.132-1.132 1.132s-1.132-.507-1.132-1.132.507-1.132 1.132-1.132 1.132.507 1.132 1.132z"/>
                                        </svg>
                                    );
                                } else {
                                    // Fallback icon for other social media
                                    IconComponent = () => (
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                                        </svg>
                                    );
                                }
                                
                                return (
                                    <a 
                                        key={index} 
                                        href={link.URL} 
                                        target="_blank" 
                                        rel="noopener noreferrer"
                                        className="w-9 h-9 flex items-center justify-center bg-[#4B4B4B] rounded-full hover:bg-[#286766] transition-all text-white"
                                    >
                                        <IconComponent />
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                    {/* Company */}
                    <div>
                        <p className="font-semibold mb-8 text-white">Onder bedrijf</p>
                        <ul className="space-y-[20px] text-sm text-white">
                            <li><a href="/projects" className="text-white hover:text-[#286766] transition-colors">Projecten</a></li>
                            <li><a href="/about" className="text-white hover:text-[#286766] transition-colors">Over ons</a></li>
                        </ul>
                    </div>

                    {/* Help */}
                    <div>
                        <p className="font-semibold mb-8 text-white">Hulp</p>
                        <ul className="space-y-[20px] text-sm text-white">
                            {footerData?.HelpLinks?.map((item, index) => (
                                <li key={index}><a href={item.URL} className="text-white hover:text-[#286766] transition-colors">{item.Label}</a></li>
                            ))}
                        </ul>
                    </div>

                    {/* Newsletter */}
                    <div>
                        <p className="font-semibold mb-8 text-white">{footerData?.NewsletterTitle}</p>
                        
                        {submitStatus && (
                            <div className={`mb-4 p-3 rounded-lg text-sm ${
                                submitStatus.type === 'success' 
                                    ? 'bg-green-100 text-green-800 border border-green-300' 
                                    : 'bg-red-100 text-red-800 border border-red-300'
                            }`}>
                                {submitStatus.message}
                            </div>
                        )}
                        
                        <form onSubmit={handleNewsletterSubmit} className="w-[300px] flex items-center bg-white rounded-lg overflow-hidden h-[55px] max-lg:md:flex-col max-lg:md:h-auto max-lg:md:w-full">
                            <input 
                                type="email" 
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Voer e-mailadres in" 
                                className="flex-1 bg-transparent px-3 py-2 text-sm outline-none text-black placeholder-gray-400" 
                                required
                                disabled={isSubmitting}
                            />
                            <button 
                                type="submit"
                                disabled={isSubmitting || !email}
                                className="w-full bg-[#286766] px-4 py-2 font-bold rounded-r-lg h-[55px] max-lg:md:h-auto hover:bg-[#1e5554] transition-colors disabled:opacity-50 disabled:cursor-not-allowed text-white"
                            >
                                {isSubmitting ? 'Verzenden...' : (footerData?.NewsletterButtonText || 'Aanmelden')}
                            </button>
                        </form>
                        
                        {/* Logo */}
                        <div className="mt-11">
                            <img src={`https://api.bouwbedrijfgeluk.nl${footerData?.Logo?.url}`} alt="Footer Logo" />
                        </div>
                    </div>
                </div>

                {/* Copyright Section */}
                <div className="border-t border-[#8A8A8A] mt-8 pt-4 text-center font-medium text-sm text-[#FAFAFA]">
                    <p className="text-white text-sm">
                        © 2025 Bouwbedrijf Geluk
                    </p>
                </div>
            </footer>
        </div>
    );
}
// bg-footer-bg